import { useTranslation } from "react-i18next";
import { Tag } from "./primitives.jsx";
import type { Delivery } from "../api/deliveries";

/**
 * Marks a delivery that runs outside any procurement contract. Such a delivery
 * is allowed only with the commercial director's prior approval, so the mark
 * has to be visible wherever the delivery is — list, board and detail alike —
 * before anyone looks for the confirm button.
 */
export function DeliveryNoContractTag({ delivery }: { delivery: Pick<Delivery, "procurementContractId"> }) {
  const { t } = useTranslation();
  if (delivery.procurementContractId) return null;
  return (
    <span title={t("deliveries.contract.noneHint", "Outside any procurement contract — a director confirms it.")}>
      <Tag kind="warning" dot={undefined} style={undefined}>
        {t("deliveries.contract.none", "Without contract")}
      </Tag>
    </span>
  );
}
